import React from 'react';
import {AsyncFileUploaderContext, defaultContextValue} from './AsyncFileUploaderContext';

export default function AsyncFileUploader(props: {
    children?: React.ReactNode
}) {
    return <AsyncFileUploaderContext.Provider value={defaultContextValue}>
        {props.children}
    </AsyncFileUploaderContext.Provider>;
}
